import React from 'react';
import { Container } from 'theme-ui';
import SEO from '../components/seo';
import PrimaryLayout from '../components/layout/primary/primary';

const aboutPage: React.FC<{}> = () => (
	<PrimaryLayout>
		<SEO title="about us" />
		<Container py="40px">
		<p><strong>Our Platform</strong></p>
		<p>Chat2Order is here to help you ease your life with convenience of buying as you chat on the go through its multi-channel shop interfaces.&nbsp;</p>
		<p>Chat2Order platform provides easy buying experiences from popular social media platform WhatsApp as well as website. Chat2Order is backed by a robust eCommerce backend to track your cart, order and automate your buying experience. You can now buy from your favourite shops with few taps while on the go.&nbsp;</p>
		<p>Check out the guide video on how to buy using our Platform - <a href="https://youtu.be/HiY2YqFcWx4">https://youtu.be/HiY2YqFcWx4</a></p>
		<p>For Sellers/Merchants -&nbsp;</p>
		<p>Chat2Order helps to drive sales growth for your business by cross selling, digital marketing &amp; targeted promotion campaigns following a marketplace business model. With Chat2Order you will quickly start selling your products &amp; services without any upfront investment. Chat2Order charges a nominal commission amount per transaction</p>
		<ul>
		<li>Boost Sales through Cross selling</li>
		<li>Seamless selling &amp; tracking experience</li>
		<li>Integrated with Payment gateway</li>
		<li>Integrated with Delivery service</li>
		<li>Feedback loop to continuously improve</li>
		<li>Keep your business open &amp; on the go</li>
		<li>Get insights from our business reports</li>
		</ul>
		<p><strong>About Us</strong></p>
		<p>Chat2Order platform is brought to you by NCOM DIGITAL SOLUTIONS LLP. NCOM Digital Solutions LLP implements innovative IT solutions for existing businesses to leverage multi-channel e<strong>N</strong>terprise <strong>COM</strong>merce. Chat2Order platform allows existing businesses to sell their products &amp; services directly to consumers.</p>
		<p><strong>Contact Us:</strong></p>
		<p>Phone/WhatsApp: +91.9051288556 / +91.9739661365</p>
		<p>Email: <a href="mailto:chat2order@gmail.com">chat2order@gmail.com</a> / <a href="mailto:info@chat2order.in">info@chat2order.in</a></p>
		<p>Registered office Address: 16F K P Roy Lane, Kolkata, West Bengal - 700031</p>
		</Container>		
	</PrimaryLayout>
);

export default aboutPage;
